import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeDocAppointedWorker = async ({ docId, WorkerIds }) => {
  const params = new URLSearchParams();
  params.append('DocId', docId);

  WorkerIds.forEach((id) => {
    params.append('WorkerIds', id);
  });

  return await request.put(
    `/Docs/appointed_worker?${params.toString()}`,
    null,
    'При изменении добавлении исполнителей у документа произошла ошибка',
    'Error'
  );
};

const useAddDocsAppointedWorker = () => {
  const mutation = useMutation(changeDocAppointedWorker, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocAppointedWorker: mutation.isLoading,
    changeDocAppointedWorker: mutation.mutateAsync,
  };
};

export default useAddDocsAppointedWorker;
